module.exports = __webpack_public_path__ + "static/media/TajawalArabic.ca4b4fb3.woff2";